module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_pn-57625b750c40aa9508d0897c8c44aec8.gif";